import { Skeleton } from '@/components/atoms/Skeleton';
import BeneficiosChippuDesktopFallback from '@/components/organisms/BeneficiosChippu/Designs/Desktop/fallback';
import MinhaCarteiraDetalhamentoFallback from '@/components/organisms/MinhaCarteiraDetalhamento/fallback';
import {
  PrimeiraSecaoHomeDesktop,
  SegundaSecaoHomeDesktop,
  UltimaSecaoHomeDesktop,
} from '../styles';

export default function HomePaginaDesktopFallback() {
  return (
    <div>
      <Skeleton style={{ height: 560 }} />
      <PrimeiraSecaoHomeDesktop>
        <BeneficiosChippuDesktopFallback />
        <Skeleton style={{ height: 510 }} />
        <Skeleton style={{ height: 234 }} />
      </PrimeiraSecaoHomeDesktop>
      <SegundaSecaoHomeDesktop>
        <Skeleton style={{ height: 809 }} />
      </SegundaSecaoHomeDesktop>
      <UltimaSecaoHomeDesktop>
        <Skeleton style={{ height: 882 }} />
        <Skeleton style={{ height: 910 }} />
        <MinhaCarteiraDetalhamentoFallback />
      </UltimaSecaoHomeDesktop>
    </div>
  );
}
